"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Controller_1 = require("../Controller");
var social_groups_api_1 = require("@wix/social-groups-api");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var _a = types_1.ApiTypes.v1.NotificationChannel, WEB = _a.WEB, MOBILE = _a.MOBILE, EMAIL = _a.EMAIL;
var CHANNELS = [EMAIL, MOBILE, WEB];
var NotificationsController = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsController, _super);
    function NotificationsController(controllerConfig, groupId) {
        var _this = _super.call(this, controllerConfig, groupId) || this;
        _this.setNotificationSettings = function (settings) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupId_1, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getGroupId()];
                    case 1:
                        groupId_1 = _a.sent();
                        return [4 /*yield*/, Promise.all(Object.keys(settings)
                                .filter(function (channel) { return settings[channel]; })
                                .map(function (channel) {
                                var notificationsReq = social_groups_api_1.getNotificationSettingsRequest(types_1.ApiTypes.v1.NotificationChannel[channel], settings[channel]);
                                return _this.api.updateNotificationSettings(groupId_1, notificationsReq);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getNotificationSettings()];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Update Notifications: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.getNotificationSettings = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var initialNotificationSettings, groupId;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setProps({
                            notificationSettings: null,
                        });
                        initialNotificationSettings = (_a = {},
                            _a[EMAIL] = undefined,
                            _a[MOBILE] = undefined,
                            _a[WEB] = undefined,
                            _a);
                        return [4 /*yield*/, this.getGroupId()];
                    case 1:
                        groupId = _b.sent();
                        return [4 /*yield*/, Promise.all(CHANNELS.map(function (channel) {
                                return _this.api
                                    .getNotificationSettings(groupId, channel)
                                    .then(function (_a) {
                                    var settings = _a.data.settings;
                                    initialNotificationSettings[channel] = social_groups_api_1.getNotificationSettingsMap(settings);
                                })
                                    .catch(function (e) { });
                            }))];
                    case 2:
                        _b.sent();
                        this.setProps({
                            notificationSettings: initialNotificationSettings,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.api = new social_groups_api_1.NotificationsApi(_this.getSiteToken(), _this.getApiBaseUrl());
        return _this;
    }
    NotificationsController.prototype.setProps = function (props) {
        this.controllerConfig.setProps(props);
    };
    NotificationsController.prototype.pageReady = function () {
        this.setProps({
            notificationActions: {
                getNotificationSettings: this.getNotificationSettings,
                setNotificationSettings: this.setNotificationSettings,
            },
            notificationSettings: undefined,
        });
        return;
    };
    return NotificationsController;
}(Controller_1.Controller));
exports.NotificationsController = NotificationsController;
//# sourceMappingURL=NotificationsController.js.map